exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1c_wNKpmpAXvDSKlyqdB51{position:absolute;top:0;bottom:0;z-index:-1}html[dir] ._1c_wNKpmpAXvDSKlyqdB51{background-color:var(--neutralLighterAlt)}html[dir=ltr] ._1c_wNKpmpAXvDSKlyqdB51,html[dir=rtl] ._1c_wNKpmpAXvDSKlyqdB51{left:0;right:0}", ""]);
// Exports
exports.locals = {
	"pastHighlight": "_1c_wNKpmpAXvDSKlyqdB51"
};